import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { formatDateToYYYYMMDD } from '../utilities/helpers';
import { count, getByEnc, search, translations } from "../utilities/api";

// eslint-disable-next-line
import i18n from "../utilities/translations";

import Header from "./Header";
import Help from "./Help";
import Options from "./Options";
import Result from "./Result";
import Search from "./Search";

const Portal = ({ client, defaultLanguage, enc }) => {
	const { t, i18n } = useTranslation();

	const [counter, setCounter] = useState(0);
	const [language, setLanguage] = useState(defaultLanguage);

	const [getCounter, setGetCounter] = useState(true);
	const [request, setRequest] = useState({
		contract: "",
		date: null,
		license: "",
		searchBy: "CONTRACT",
		time: "",
	});
	const [result, setResult] = useState({
		error: null,
		data: null,
		type: null
	});
	const [showHelp, setShowHelp] = useState(false);


	useEffect(() => {
		const searchByQueryString = async (language, client, enc) => {
			const searchResult = await getByEnc(language, client, enc);

			if (!searchResult.data) {
				setResult({
					...result,
					error: searchResult.error,
					data: null,
					type: "LICENSE"
				});

			} else {
				setResult({
					...result,
					error: searchResult.error,
					data: [searchResult.data],
					type: "LICENSE"
				});

				setRequest({
					...request,
					contract: "",
					date: searchResult.data.od,
					license: searchResult.data.lp,
					searchBy: "LICENSE",
					time: searchResult.data.ot,
				});
			}
			setGetCounter(true);
		};
		if (!enc)
			return;
		window.history.replaceState(null, "", "/");
		searchByQueryString(defaultLanguage, client, enc);

	}, [enc]);

	useEffect(() => {
		setLanguage(defaultLanguage);

	}, [defaultLanguage]);

	useEffect(() => {
		const loadTranslations = async () => {
			if (!(language in i18n.store.data)) {
				const response = await translations(language);
				i18n.addResourceBundle(language, "translation", response, true, true);
			}
			i18n.changeLanguage(language);
		};
		if (language) loadTranslations();
	}, [language, i18n]);

	useEffect(() => {
		const getCount = async () => {
			if (!client) return;
			const response = await count(client);
			setCounter(response);
			setGetCounter(false);

		};

		if (getCounter) getCount();

	}, [getCounter, client]);

	const handleChange = (name, val) => {

		let value;
		switch (name) {
			case "date":
				value = formatDateToYYYYMMDD(val);
				break;
			default:
				value = val.toUpperCase();
		}
		setRequest({
			...request,
			[name]: value,
		});

	};

	const handleOptionChange = (option) => {
		setRequest({
			...request,
			searchBy: option,
		});
		setResult({
			error: null,
			data: null,
			type: null
		});
	};

	const handleSearch = async (e) => {
		e.preventDefault();
		const isValid = () => {
			if (request.searchBy === "LICENSE")
				return request.license !== "" && request.date !== "" && request.time !== "";
			return request.contract !== "" && request.license !== "";
		};

		if (isValid() === false) {
			setResult({
				error: "noresultfound",
				data: null,
				type: request.searchBy
			});
			return;
		}

		const searchResult = await search(language, client, request);
		setResult({
			...result,
			error: searchResult.error,
			data: searchResult.data,
			type: request.searchBy
		});
		setGetCounter(true);
	};

	return (
		<>
			{showHelp && <Help language={language} client={client} onClose={() => setShowHelp(false)} title={t("faq")} />}
			<div className="container">
				<Header
					onLanguageChange={(lan) => setLanguage(lan)}
					onHelpClick={() => setShowHelp(true)}
				/>

				<div className="main">
					<div className="introduction">
						<h3>{t("finereceived")}</h3>
						<p>{t("2waystosearch")}</p>
					</div>
				</div>

				<Options
					option={request.searchBy}
					onOptionChange={(option) => handleOptionChange(option)}
				/>

				{/* Form */}
				<Search
					language={language}
					option={request.searchBy}
					request={request}
					onChange={(name, val) => handleChange(name, val)}
					onSearch={handleSearch}
				/>

				{result.error && <div className="alert alert-danger">{t(result.error)}</div>}
				{result.data && <Result language={language} client={client} result={result.data} option={request.searchBy} />}

				{/* Counter */}
				<div style={{ textAlign: "center" }}>{counter}</div>
			</div>
		</>
	);
};

export default Portal;
